import { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { API_URL } from "../../shared/constant";
import { toast } from "react-toastify";
import { Watch } from "react-loader-spinner";
import axios from "axios";
import Select from "react-select";
import DatePicker from "react-date-picker";
import moment from "moment";

const customStyles = {
  input: (base) => ({ ...base, fontWeight: 400 }),
  valueContainer: (base) => ({ ...base, fontWeight: 400 }),
};

const Add = () => {
  let { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [productDrpData, setProductDrpData] = useState([]);
  const [invoiceDate, setInvoiceDate] = useState();
  const [formData, setFormData] = useState({
    product_id: "",
    price: "",
    opening_stock: "",
    opening_stock_date: null,
    stock_remind: "",
    sub_products: []
  });

  const getProductData = () => {
    axios.post(API_URL.PRODUCT_ONLY, {}).then((res) => {
      let cd = res.data.data.map((caw) => {
        return {
          label: caw.category?.name + ' - ' + caw.name,
          value: caw.id,
          product_id: caw.product_id,
          weight: caw.weight,
          price: caw.price,
        };
      });
      setProductDrpData(cd);
    });
  };

  const showProductDetails = () => {
    axios.post(API_URL.SUB_PRODUCT_LIST, { product_id: formData.product_id }).then((res) => {
      if (res.data.status === 1) {
        let sub_products = res.data.data.map((caw) => {
          return {
            name: caw.name,
            id: caw.id,
            weight: caw.weight,
            price: caw.price,
            size_name: caw.size_name,
            price: caw.price,
            opening_stock: "",
            opening_stock_date: null,
            stock_remind: "",
          };
        });
        setFormData({ ...formData, sub_products: sub_products });
      }
    });
  };

  const onSave = () => {
    console.log(formData);
    if (formData.product_id && formData.price && formData.price > 0) {
      setLoading(true);
      let payload = { ...formData };
      if (invoiceDate) {
        payload.opening_stock_date = moment(invoiceDate).format("YYYY-MM-DD");
      } else {
        payload.opening_stock_date = null;
      }

      const pUrl = id ? API_URL.MY_PRODUCT_UPDATE : API_URL.MY_PRODUCT_SAVE;
      axios
        .post(pUrl, payload)
        .then((res) => {
          if (res.data.status === 1) {
            let message = id
              ? "Product Updated Successfully."
              : "Product Created Successfully.";
            toast.success(message, { autoClose: 3000, position: "top-right" });
            setLoading(false);
            navigate("/my-products");
          }
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      toast.error("Please fill all the required fields", { autoClose: 3000, position: "top-right" });
      setLoading(false);
    }
  };

  const onEdit = () => {
    axios.post(API_URL.MY_PRODUCT_GET, { id: id }).then((res) => {
      if (res.data.status === 1) {
        setFormData({
          id: res.data.data.id,
          product_id: res.data.data.product_id,
          price: res.data.data.price ? res.data.data.price : "",
          opening_stock: res.data.data.opening_stock ? res.data.data.opening_stock : "",
          opening_stock_date: null,
          stock_remind: res.data.data.stock_remind || res.data.data.remainder || "",
          sub_products: res.data.data.subproducts ? res.data.data.subproducts : []
        });
        setProductDrpData([{
          label: res.data.data.product.name,
          value: res.data.data.product_id,
          product_id: res.data.data.product_id,
          weight: res.data.data.product.weight,
          price: res.data.data.price,
        }]);
        if (res.data.data.opening_stock_date) {
          setInvoiceDate(new Date(res.data.data.opening_stock_date));
        }
      }
    });
  };

  useEffect(() => {
    if (!id) {
      getProductData();
    }
  }, []);

  useEffect(() => {
    if (formData.product_id && !id) {
      showProductDetails();
    }
  }, [formData.product_id]);

  useEffect(() => {
    if (id) {
      onEdit();
    }
  }, [id]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <h1>{id ? "Edit" : "Add"} Product</h1>
        </div>
        <div className="col-6">
          <div className="d-flex align-items-center  justify-content-end">
            <Link to={"/my-products"} className="btn btn-secondary">
              <i className="fa fa-backward me-2" aria-hidden="true"></i>Back
            </Link>
          </div>
        </div>
      </div>
        <div className="card">
          <div className="card-body">
            <form onSubmit={(event) => event.preventDefault()}>
              <div className="row">
                <div className="col-md-4">
                  <div className="form-group">
                    <label>Product<span className="required-star">*</span></label>
                    <Select
                        options={productDrpData}
                        value={productDrpData.find((r) => r.value == formData.product_id)}
                        styles={customStyles}
                        isDisabled={ id ? true : false }
                        onChange={(e) => {
                            setFormData({ ...formData, product_id: e.value });
                        }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label>Price<span className="required-star">*</span></label>
                    <input
                      type="number"
                      name="price"
                      maxLength={6}
                      value={formData.price}
                      className="form-control" id="price"
                      onChange={(event) => {
                        setFormData({ ...formData, price: event.target.value });
                      }}
                    />
                  </div>
                </div>
                <div className="col-md-2">
                  <div className="form-group">
                    <label>Stock Remind</label>
                    <input
                      type="number"
                      name="stock_remind"
                      maxLength={30}
                      value={formData.stock_remind}
                      className="form-control" id="stock_remind"
                      onChange={(event) => {
                        setFormData({ ...formData, stock_remind: event.target.value });
                      }}
                    />
                  </div>
                </div>
                {formData.product_id && <>
                {formData.sub_products.length === 0 && <div className="col-md-2">
                  <div className="form-group">
                    <label>Opening Stock</label>
                    <input
                      type="number"
                      name="opening_stock"
                      maxLength={30}
                      value={formData.opening_stock}
                      className="form-control" id="opening_stock"
                      onChange={(event) => {
                        setFormData({ ...formData, opening_stock: event.target.value });
                      }}
                    />
                  </div>
                </div>}
                <div className="col-md-2">
                  <div className="form-group">
                    <label htmlFor="">Opening Stock Date</label>
                    <DatePicker
                      format={"dd/MM/y"}
                      className="form-control"
                      onChange={setInvoiceDate}
                      value={invoiceDate}
                    />
                  </div>
                </div>
                {formData.sub_products.length === 0 && <div className="col-md-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={onSave}
                      disabled={loading}
                      className="btn btn-primary mt-4"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>}
                </> }
                {formData.sub_products.length > 0 && <><div className="col-md-6">
                  <div className="form-group">
                    <label>Sub Products</label>
                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead>
                          <tr>
                            <th>Name</th>
                            <th>Opening Stock</th>
                          </tr>
                        </thead>
                        <tbody>
                          {formData.sub_products.map((sub_product, index) => (
                            <tr key={index}>
                              <td>{sub_product.name}</td>
                              <td><input type="number" className="form-control" name="opening_stock" value={sub_product.opening_stock} onChange={(event) => {
                                setFormData({ ...formData, sub_products: formData.sub_products.map((caw) => caw.id === sub_product.id ? { ...caw, opening_stock: event.target.value } : caw) });
                              }} /></td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div></> }

                {formData.sub_products.length > 0 && <div className="col-md-12">
                  <div className="form-group text-right">
                    <button
                      type="submit"
                      onClick={onSave}
                      disabled={loading}
                      className="btn btn-primary mt-4"
                    >
                      {loading ? (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Watch color={"white"} height={20} width={20} />
                        </div>
                      ) : (
                        "Save"
                      )}
                    </button>
                  </div>
                </div>}
              </div>
            </form>
          </div>
        </div>
    </>
  );
};

export default Add;
